export default __webpack_public_path__ + "static/media/unexploitableIcon.39a741d0.svg";